import React, { useState } from 'react';
import { Typography, Button, Space, Alert, Upload } from 'antd';
import { UploadOutlined, PaperClipOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const { Title } = Typography;

const DUMMY_ADDITIONAL_DOCS = [
  {
    id: 1,
    name: 'filename.png',
    link: 'https://yuhu.io/',
  },
  {
    id: 2,
    name: 'other-file.png',
    link: 'https://yuhu.io/',
  },
];

const StyledSpace = styled(Space)`
  display: block;
  margin-bottom: 16px;
`;

const AdditionalDoc = styled.div`
  a {
    margin-left: 8px;
  }
`;

const StyledAlert = styled(Alert)`
  margin-bottom: 16px;
`;

const AdditionalDocuments = () => {
  const [showError, setShowError] = useState(false);

  const uploadProps = {
    action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
    showUploadList: false,
    beforeUpload(file) {
      const isSmallEnough = file.size / 1024 / 1024 < 15;
      if (!isSmallEnough) {
        setShowError(true);
      }

      return false;
    },
  };

  return (
    <>
      <Title level={4}>Additional Documents</Title>

      <StyledSpace direction="vertical">
        {DUMMY_ADDITIONAL_DOCS.map((doc) => (
          <AdditionalDoc key={doc.id}>
            <PaperClipOutlined />
            <a href={doc.link}>{doc.name}</a>
          </AdditionalDoc>
        ))}
      </StyledSpace>

      {showError ? (
        <StyledAlert
          message="The file you selected is too large, the limit is 15MB."
          type="error"
          showIcon
        />
      ) : null}

      <Upload {...uploadProps}>
        <Button size={'middle'} icon={<UploadOutlined />}>
          Upload
        </Button>
      </Upload>
    </>
  );
};

export default AdditionalDocuments;
